// Component subdirectory name
export const COMPONENT_SUBDIR = "tambo";

// Legacy subdirectory for migration
export const LEGACY_COMPONENT_SUBDIR = "ui";
